import BaseModel from "../../../core/components/input-widget/BaseModel";
import i18n from "@/shared/i18n";

export default class InventoryOverviewGenerationModel extends BaseModel {
  language = null

  rules = {
    language: 'required'
  }

  attributeLabels = {
    language: i18n.t('Language')
  }

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }
}
